import { createIcon } from '@chakra-ui/react';

export const InfoTooltip = createIcon({
  displayName: 'InfoTooltip',
  viewBox: '0 0 16 16',
  defaultProps: {
    fill: 'none',
    height: '16',
    width: '16',
  },
  path: (
    <>
      <path
        d="M7.33301 4.66671H8.66634V6.00004H7.33301V4.66671ZM7.33301 7.33337H8.66634V11.3334H7.33301V7.33337ZM7.99967 1.33337C4.31967 1.33337 1.33301 4.32004 1.33301 8.00004C1.33301 11.68 4.31967 14.6667 7.99967 14.6667C11.6797 14.6667 14.6663 11.68 14.6663 8.00004C14.6663 4.32004 11.6797 1.33337 7.99967 1.33337ZM7.99967 13.3334C5.05967 13.3334 2.66634 10.94 2.66634 8.00004C2.66634 5.06004 5.05967 2.66671 7.99967 2.66671C10.9397 2.66671 13.333 5.06004 13.333 8.00004C13.333 10.94 10.9397 13.3334 7.99967 13.3334Z"
        fill="#486581"
      />
    </>
  ),
});
